/* eslint-disable */

// Single source of truth for choosing which generated certificate component to
// render for a company + inspection state. Mirrors the Dashboard's
// selectedCompaniesModal getCertificateRoute() precedence so every Frontend
// entry point (certificates page, reviewed tiles, status tabs, company modal)
// stays consistent. The first matching condition wins.

import GeneralCertificate from "./GeneralCertificate";
import UberCertificate from "./UberCertificate";
import UberNevadaCertificate from "./UberNevadaCertificate";
import UberRasierCertificate from "./UberRasierCertificate";
import UberArkansasCertificate from "./UberArkansasCertificate";
import UberAlabamaCertificate from "./UberAlabamaCertificate";
import UberCertificateScNcGe from "./UberCertificateScNcGe";
import ColoradoTncCertificate from "./ColoradoTncCertificate";
import TuroCertificate from "./TuroCertificate";
import HopeSkipDriveCertificate from "./HopeSkipDriveCertificate";
import GetAroundCertificate from "./GetAroundCertificate";
import EverDrivenCertificate from "./EverDrivenCertificate";
import EverDrivenAnnualCertificate from "./EverDrivenAnnualCertificate";

import Lyftcertificate from "./Lyftcertificate";
import LyftCertificateArizona from "./LyftCertificateArizona";
import LyftCertificateSouthCarolina from "./LyftCertificateSouthCarolina";
import LyftCertificateNevada from "./LyftCertificateNevada";
import LyftCertificateNewMexico from "./LyftCertificateNewMexico";
import LyftCertificateMichigan from "./LyftCertificateMichigan";
import LyftCertificateArkansas from "./LyftCertificateArkansas";
import LyftCertificateAlabama from "./LyftCertificateAlabama";
import LyftCertificateOhioNebraskaIdahoIowa from "./LyftCertificateOhioNebraskaIdahoIowa";
import LyftCertificateAllOthers from "./LyftCertificateAllOthers";

// Inspection states (exact-case) treated as California for Lyft / EverDriven.
export const californiaInspectionStates = [
  "Northern California (Bay Area)",
  "Northern California (Sacramento Region)",
  "Northern California (Other)",
  "Central California",
  "Southern California (LA region)",
  "Southern California (Orange County)",
  "Southern California (San Diego Region)",
  "Southern California (Other)",
];

// certificateData: { companyName, templateId, ... }
export const resolveCertificateComponent = (certificateData, inspectionState) => {
  const name = certificateData?.companyName;
  const lowerName = name?.toLowerCase();
  const templateId = certificateData?.templateId;
  const state = inspectionState;
  const lowerState = state?.toLowerCase();

  const isCalifornia =
    lowerState === "california" ||
    californiaInspectionStates.some((s) => s.toLowerCase() === lowerState);

  if (templateId === 4 && lowerName === "turo") {
    return TuroCertificate;
  }

  if (templateId === 3 && lowerName === "lyft") {
    if (isCalifornia) return Lyftcertificate;
    if (lowerState === "south carolina") return LyftCertificateSouthCarolina;
    if (lowerState === "arizona") return LyftCertificateArizona;
    if (lowerState === "nevada") return LyftCertificateNevada;
    if (lowerState === "new mexico") return LyftCertificateNewMexico;
    if (lowerState === "colorado") return ColoradoTncCertificate;
    if (lowerState === "michigan") return LyftCertificateMichigan;
    if (lowerState === "arkansas") return LyftCertificateArkansas;
    if (lowerState === "alabama") return LyftCertificateAlabama;
    if (
      lowerState === "ohio" ||
      lowerState === "nebraska" ||
      lowerState === "idaho" ||
      lowerState === "iowa" ||
      lowerState === "lowa"
    ) {
      return LyftCertificateOhioNebraskaIdahoIowa;
    }
    return LyftCertificateAllOthers;
  }

  if (templateId === 2 && lowerName === "hopskipdrive") {
    return HopeSkipDriveCertificate;
  }

  if (lowerName === "uber") {
    if (lowerState === "nevada") return UberNevadaCertificate;
    if (lowerState === "colorado") return ColoradoTncCertificate;
    if (lowerState === "arkansas") return UberArkansasCertificate;
    if (lowerState === "alabama") return UberAlabamaCertificate;
    if (
      lowerState === "south carolina" ||
      lowerState === "north carolina" ||
      lowerState === "georgia"
    ) {
      return UberCertificateScNcGe;
    }
    if (
      lowerState === "ohio" ||
      lowerState === "nebraska" ||
      lowerState === "idaho" ||
      lowerState === "iowa" ||
      lowerState === "lowa" ||
      lowerState === "new mexico"
    ) {
      return UberRasierCertificate;
    }
    return UberCertificate;
  }

  if (lowerName === "everdriven") {
    return isCalifornia ? EverDrivenCertificate : EverDrivenAnnualCertificate;
  }

  if (name === "getaround") return GetAroundCertificate;

  if (lowerName === "lyft") return LyftCertificateAllOthers;

  return GeneralCertificate;
};
